import Skeleton from '@cvent/carina/components/Skeleton';
import {Card} from '../card/Card';
import {useSkeletonDelay} from './useSkeletonDelay';

/**
 * Skeleton for simple single-purpose form pages (ForgotPassword, ActivatePassword, VerifyEmail, etc.)
 * Centered layout with back button and 1-3 form fields
 * Includes a 300ms delay to prevent flash on fast-loading pages
 */
export const SimpleFormSkeleton = () => {
  const show = useSkeletonDelay();

  if (!show) {
    return null;
  }

  return (
    <div className="h-full flex flex-col justify-center items-center -mt-[var(--carina-spacing-12)]">
      <Card styleClasses="px-9 py-6 w-[372px] box-border max-w-full">
        <div className="flex flex-col gap-6 items-start w-full">
          {/* Back button */}
          <Skeleton className="w-[80px] h-[32px] rounded" hasShimmer />

          {/* Title and description */}
          <div className="flex flex-col gap-2 items-start w-full">
            <Skeleton className="w-full h-[28px] rounded" hasShimmer />
            <Skeleton className="w-full h-[20px] rounded" hasShimmer />
            <Skeleton className="w-[80%] h-[20px] rounded" hasShimmer />
          </div>

          {/* Form fields (1-3 fields) */}
          <div className="flex flex-col items-center w-full gap-4">
            {Array.from({length: 2}).map((_, index) => (
              <div key={index} className="w-full">
                <Skeleton
                  className="w-[80px] h-[16px] rounded mb-2"
                  hasShimmer
                />
                <Skeleton className="w-full h-[40px] rounded" hasShimmer />
              </div>
            ))}
          </div>

          {/* Submit button */}
          <Skeleton className="w-full h-[36px] rounded" hasShimmer />

          {/* Optional secondary text/link */}
          <div className="w-full flex justify-center">
            <Skeleton className="w-[200px] h-[16px] rounded" hasShimmer />
          </div>
        </div>
      </Card>
    </div>
  );
};
